export default "__VITE_ASSET__oL6mmWcO__"